var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#fff","d":"M0 10h8V0H0zm0 8h8v-6H0zm10 0h8V8h-8zm0-18v6h8V0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }